import { signal } from "./deps.ts";
import { SynthesisStoreType } from "./types.ts";

export const SynthesisStore = signal<SynthesisStoreType>(null);
